import { WordSearchPuzzle } from '@/wordsearch/types';
import { setSeed, getRandomNumber } from '@/wordsearch/random';
import { generate, WordSearch } from '@/wordsearch/generate';
import nouns from '@/wordsearch/nouns';

function convertSBJ42(puzzle: WordSearch, width: number, height: number): WordSearchPuzzle {
  const cells = puzzle.grid.map((letter, index) => ({
    id: index.toString(),
    x: index % width,
    y: Math.floor(index / height),
    letter,
  }));

  const answers = Object.entries(puzzle.answers).reduce((acc, [key, val]) => {
    acc[key] = val.map(([x, y]) => cells.find((cell) => cell.x === x && cell.y === y)!.id);
    return acc;
  }, {} as Record<string, string[]>);

  return {
    width: puzzle.width,
    height: puzzle.height,
    words: puzzle.words,
    cells,
    answers,
  };
}

function getWords(amount: number): string[] {
  const words: string[] = [];

  const locale = window.location.search.includes('lang=de') ? 'de' : 'en';
  const nounsLang = nouns[locale];

  while (words.length < amount) {
    const word = nounsLang[Math.floor(getRandomNumber() * nounsLang.length)];
    if (!words.includes(word)) words.push(word);
  }

  return words.map((v) => v.toUpperCase());
}

function generatePuzzle(
  width: number,
  height: number,
  wordsAmount: number,
  date: string,
): WordSearchPuzzle {
  setSeed(new Date(date).getTime());

  const words = getWords(15);
  const rawPuzzle = generate({ words, width, height });

  return convertSBJ42(rawPuzzle, width, height);
}

export default function generatePuzzleFromDate(date: string): WordSearchPuzzle {
  return generatePuzzle(15, 15, 15, date);
}
